import { useTranslation } from 'react-i18next'

import { FormatPrice } from '@reveni-io/reveni-ui'

import { heatMapOptions } from '@/metrics/pages/DashboardPage/ShipmentsMetricsContent/constants'

import * as Styles from './styles'

const Tooltip = ({ tooltip, orderBy, currency }) => {
  const { t } = useTranslation()

  const getValueByOrderBy = () => {
    if (orderBy === heatMapOptions.totalOrdersCount) {
      return t('{{value}} pedidos', { value: tooltip.value })
    } else if ([heatMapOptions.totalOrderValue, heatMapOptions.averageOrderValue, heatMapOptions].includes(orderBy)) {
      return <FormatPrice currency={currency}>{tooltip.value}</FormatPrice>
    } else if (orderBy === heatMapOptions.incidentsInCustoms) {
      return t('{{value}} incidentes', { value: tooltip.value })
    }
  }

  return (
    <Styles.TooltipContainer tooltip={tooltip}>
      {tooltip.name} ({getValueByOrderBy()})
    </Styles.TooltipContainer>
  )
}

export default Tooltip
